<template>
  <div
    v-if="isPdfPreview"
    class="form-control"
  >
    {{ day }}/{{ month }}/{{ year }}
  </div>
  <Datepicker
    v-else
    ref="form"
    :default-date="value"
    display-format="dmy"
    :on-day-change="onDayChange"
    :on-month-change="onMonthChange"
    :on-year-change="onYearChange"
    :min-age="minAge"
    :max-age="maxAge"
    :day-label="dayLabelData"
    :month-label="monthLabelData"
    :year-label="yearLabelData"
  />
</template>
<script>
import moment from 'moment'
import Datepicker from './DropdownDatepicker.vue'
export default {
  name: 'DropdownDatepicker',
  components: {
    Datepicker,
  },
  props: {
    value: { type: String, default: '' },
    minAge: {
      type: Number,
      default: 0,
    },
    maxAge: {
      type: Number,
      default: 100,
    },
    dayLabel: {
      type: String,
      default: 'Day',
    },
    monthLabel: {
      type: String,
      default: 'Month',
    },
    yearLabel: {
      type: String,
      default: 'Year',
    },
  },
  data() {
    return { ...this.parseDate(this.value), isPdfPreview: false,dayLabelData: this.dayLabel,
      monthLabelData: this.monthLabel,
      yearLabelData: this.yearLabel, }
  },
  watch: {
    value: function (newVal, oldVal) {
      var newData = this.parseDate(newVal)
      this.day = newData.day
      this.month = newData.month
      this.year = newData.year
    },
    dayLabel: function (val) {
      if (this.dayLabelData !== val) {
        this.dayLabelData = val
        this.$refs.form.changeLabel(true, false, false, val)
      }
    },
    monthLabel: function (val) {
      if (this.monthLabelData !== val) {
        this.monthLabelData = val
        this.$refs.form.changeLabel(false, true, false, val)
      }
    },
    yearLabel: function (val) {
      if (this.yearLabelData !== val) {
        this.yearLabelData = val
        this.$refs.form.changeLabel(false, false, true, val)
      }
    },
  },
  mounted() {
    this.isPdfPreview = this.$root.inPdfPreviewForm(this.$el)
  },
  methods: {
    parseDate(value) {
      if (value) {
        var date = moment(value, 'YYYY-MM-DD')

        if (date.isValid()) {
          return {
            day: date.date(),
            month: date.month() + 1,
            year: date.year(),
          }
        }
      }
      return {
        day: null,
        month: null,
        year: null,
      }
    },
    onDayChange(value) {
      this.day = value
      this.emitChange()
    },
    onMonthChange(value) {
      this.month = value
      this.emitChange()
    },
    onYearChange(value) {
      this.year = value
      this.emitChange()
    },
    emitChange() {
      if (this.year == null || this.month == null || this.day == null) {
        return
      }
      const newValue = moment([this.year, this.month - 1, this.day]).format('YYYY-MM-DD')
      this.$emit('input', newValue)
    },
    clearData() {
      this.day = null
      this.month = null
      this.year = null
      this.$refs.form.clearData()
    },
    validateAge(min = 0, max = 100) {
      this.minAge = min
      this.maxAge = max
      this.$refs.form.validateAge(min, max)
    },
  },
}
</script>

<style lang="scss"></style>
